import { ipCheckerHost } from 'api'

import { showUrlWindow } from './showUrlWindow'

export const showIpCheckerWindow = (url: string): void => {
  showUrlWindow(`${ipCheckerHost}/${url}`)
}
